import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAgentChatRunStalled.meta';

export type UseTrackAgentChatRunStalledParams = {
  canvas_id: string;
  thread_id: string;
  run_id?: string;
  action?: string;
  elapsed_ms: number;
  run_finished_received: boolean;
  result_arrived: boolean;
  tab_hidden: boolean;
  trigger: 'timer' | 'tab_return' | 'reconnect';
};

export const useTrackAgentChatRunStalled = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentChatRunStalled = useCallback(
    (params: UseTrackAgentChatRunStalledParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackAgentChatRunStalled };
};
